import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE || "http://localhost:5000/api";

export default axios.create({
  baseURL,
});
